module.exports = __webpack_public_path__ + "img/software_img2.a109a464.png";